// async and await will not work without this import
require('babel-polyfill');
const photoswipe = require('plugin_catalog/product-detail/photoswipe');
const simpleCalendar = require('./components/vendor/jquery.simple-calendar');
window.onjQueryLoad(function () {
    $('.js-show-stores-all').on('click', function () {
        $('.store-locator-all').addClass('d-none').removeClass('d-block');
        $('.nearest-store').removeClass('d-none');
    });

    // Initializing zoom function and gallery for store photos
    photoswipe.init();

    require('./components/store-locator-map');
    require('./components/store-dialog');
    require('./components/store-events');
}, true);
